import { Injectable } from '@angular/core';
import { GIPPackagingConstants } from '@core/constants/gip-packaging.constants';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor(private translate: TranslateService) { }

  setDefaultLang = () => {
    this.translate.setDefaultLang(GIPPackagingConstants.DEFAULT_MARKET_LANG);
    this.translate.use(GIPPackagingConstants.DEFAULT_MARKET_LANG);
  }
}
